import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";

export class OmsOrderAdditionsMultiSelectComponent implements IController {

  selectedAdditions: any;
  options: any;
  ngPlaceholder: any;
  isRequired: boolean;
  onChange: Function;

  public selectedText: any;
  public additionsCountMap: {};

  constructor(private $mdPanel) {
  }

  $onInit() {
    this._setSelectedText();
  };

  $onChanges(changes) {
    if (changes.selectedAdditions && !changes.selectedAdditions.isFirstChange()) {
      this._setSelectedText();
    }
  };


  onShowPanel($event) {

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const additionsRef = this.selectedAdditions || [];
    const optionsRef = this.options;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'additions';
        this.selectedIdsRef = additionsRef;
        this.optionsRef = optionsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, additions) => {
        if (additions === 'clickOutsideToClose' || additions === 'escapeToClose') {
          additions = additionsRef;
        }

        if (!additions?.length) {
          this.onChange({additions: []});
        } else {
          this.onChange({additions: additions});
        }
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({additions: []});
  }

  private _setSelectedText() {
    let string = '';

    this.additionsCountMap = {};
    this.selectedAdditions?.forEach(a => {
      if (_.isUndefined(this.additionsCountMap[a.name])) {
        this.additionsCountMap[a.name] = 0
      }
      this.additionsCountMap[a.name] = this.additionsCountMap[a.name] + 1;
    });

    const additionKeys = Object.keys(this.additionsCountMap);
    additionKeys.forEach((key, index) => {
      string += `x${this.additionsCountMap[key]} ${key} `;
      if ((index + 1) < additionKeys.length) {
        string += ', '
      }
    });

    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.oms')
  .component('omsOrderAdditionsMultiSelect', {
    bindings: {
      selectedAdditions: '<?',
      options: '<?',
      isRequired: '<?',
      onChange: '&'
    },
    template: require('./oms-order-additions-multi-select.html').default,
    controller: OmsOrderAdditionsMultiSelectComponent
  });
